import {
  Modal,
  Fade,
  Typography,
  Box,
  Button,
  IconButton,
  TextField,
  Stack,
  Backdrop,
  CircularProgress,
  Paper,
  RadioGroup,
  Radio,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { API, graphqlOperation } from 'aws-amplify';
import { createNumberTracker, updateNumberTracker } from '../../graphql';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../snackBar/snakbar';
import { useEffect, useState } from 'react';
import { defaultSettings } from '../../utils/Data/StaticData';
import { useSelector } from 'react-redux';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  outline: 'none',
};

const GeneralSettings = ({ open, setOpen, item, setItem, editId, setId, setEditID, listItems, setListItems, label, setting }) => {
  const [backdropOpen, setBackdropOpen] = useState(false);
  const getCompany = useSelector((state) => state?.companyReducer.companyDetails);
  const regType = getCompany.relatedcompanydetailsnew[0].registrationtype;
  const unRegCompBool = regType == 1 || regType == 3;
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
      setEditID('');
      setItem(defaultSettings);
    }
  };
  const labelFn = (lab) => {
    if (lab === 'SalesInvoice' || lab === 'PurchaseInvoice' || lab === 'PosInvoice' || lab === 'CreditInvoice' || lab === 'DebitInvoice') {
      return lab.replace(/([A-Z][^A-Z]*)([A-Z])/, '$1 $2');
    } else {
      return lab;
    }
  };
  const convertBooleanToInt = (obj) => {
    const newObj = { ...obj };
    Object.keys(newObj).forEach((key) => {
      if (typeof newObj[key] === 'boolean') {
        newObj[key] = newObj[key] ? 1 : 0;
      }
    });
    return newObj;
  };
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!open) return;
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
        e.preventDefault();
        if (!item?.nextinvoicenumber) {
          return;
        }

        handleSetting();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, item?.nextinvoicenumber, setting]); // Add necessary dependencies
  console.log(item, 'item');

  const updatedObjectWithInt = convertBooleanToInt(item);
  const handleSetting = async () => {
    const items = [...listItems];
    const itemsExceptCurrent = items.filter((i) => i.id != editId.id);
    if (item.nextinvoicenumber === '') {
      showWarningSnackbar('Please enter the start number');
    } else if (
      editId.id &&
      editId.prefix === item.prefix &&
      editId.suffix === item.suffix &&
      editId.nextinvoicenumber !== item.nextinvoicenumber
    ) {
      setBackdropOpen(true);
      const salesSettingsData = {
        id: Number(updatedObjectWithInt.id),
        companyid: getCompany?.companyid,
        entrytypecd: label,
        nextinvoicenumber: Number(updatedObjectWithInt.nextinvoicenumber),
        financialyearid: setId,
        prefix: updatedObjectWithInt.prefix,
        serialisused: updatedObjectWithInt.serialisused,
        suffix: item.suffix ? updatedObjectWithInt.suffix : '',
        serialnumber:
          item.prefix && item.suffix
            ? `${item.prefix.trim()}/${item.suffix.trim()}`
            : item.suffix
            ? item.suffix.trim()
            : item.prefix
            ? item.prefix.trim()
            : '',
        serialisactive: updatedObjectWithInt.serialisactive,
        // serialflag: updatedObjectWithInt.serialflag,
        serialflag: updatedObjectWithInt.taxability === 3 ? 1 : 0,
        taxability: updatedObjectWithInt.taxability,
        restrictedflag: updatedObjectWithInt.restrictedflag,
        startinvoicenumber:
          updatedObjectWithInt.serialisused === 1
            ? updatedObjectWithInt?.startinvoicenumber
            : Number(updatedObjectWithInt.nextinvoicenumber),
      };
      try {
        const resSalesSettings = await API.graphql(
          graphqlOperation(updateNumberTracker, {
            updateNumberTrackerInput: salesSettingsData,
          })
        );
        if (resSalesSettings.data.updateNumberTracker.statuscode !== 'ERROR') {
          setListItems([...listItems]);
          showSuccessSnackbar('Setting has been modified');
          handleClose();
          setEditID('');
          setItem(defaultSettings);
          setBackdropOpen(false);
        } else {
          showWarningSnackbar(resSalesSettings.data.createNumberTracker[0]?.statusmessage);
        }
      } catch (err) {
        console.log(err, 'errr');
        const rawMessage = err.errors[0].message.split('RDSHttp:')[1];
        const parsedMessage = JSON.parse(rawMessage).message;
        const errMessage = parsedMessage.split(';')[0].replace(/^ERROR:\s*/, '');
        showWarningSnackbar(errMessage);
      } finally {
        setBackdropOpen(false);
      }
    } else {
      const isMatchFound = itemsExceptCurrent.some((set) => {
        if (item.prefix?.trim() === '' && item.suffix?.trim() === '' && set.prefix === item.prefix && set.suffix === item.prefix) {
          return true;
        }
        return item?.prefix?.trim() !== '' && item?.prefix?.trim().toUpperCase() === set?.prefix?.trim().toUpperCase()
          ? item.suffix?.trim().toUpperCase() === set.suffix?.trim().toUpperCase() && true
          : item?.prefix?.trim().toUpperCase() === '' &&
            item?.suffix?.trim().toUpperCase() !== '' &&
            item?.suffix?.trim().toUpperCase() === set?.suffix?.trim().toUpperCase() &&
            set.prefix === ''
          ? true
          : false;
      });
      const isMatchFound2 = itemsExceptCurrent.some((set) => {
        if (item.prefix === '' && item.suffix === '' && set.prefix === item.prefix && set.suffix === item.prefix) {
          return true;
        }
        return item?.suffix?.trim() !== '' && item?.suffix?.trim().toUpperCase() === set?.suffix?.trim().toUpperCase()
          ? item.prefix?.trim().toUpperCase() === set.prefix?.trim().toUpperCase() && true
          : item?.suffix?.trim().toUpperCase() === '' &&
            item?.prefix?.trim().toUpperCase() !== '' &&
            item?.prefix?.trim().toUpperCase() === set?.prefix?.trim().toUpperCase() &&
            set.suffix === ''
          ? true
          : false;
      });
      if (isMatchFound === true && isMatchFound2 === true) {
        showErrorSnackbar(`This ${label} setting already exists`);
      } else if (editId.id) {
        setBackdropOpen(true);
        const salesSettingsData = {
          id: Number(updatedObjectWithInt.id),
          companyid: getCompany?.companyid,
          entrytypecd: label,
          nextinvoicenumber: Number(updatedObjectWithInt.nextinvoicenumber),
          financialyearid: setId,
          prefix: updatedObjectWithInt.prefix,
          serialisused: updatedObjectWithInt.serialisused,
          suffix: item.suffix ? updatedObjectWithInt.suffix : '',
          startinvoicenumber:
            updatedObjectWithInt.serialisused === 1
              ? updatedObjectWithInt?.startinvoicenumber
              : Number(updatedObjectWithInt.nextinvoicenumber),
          serialnumber:
            item.prefix && item.suffix
              ? `${item.prefix.trim()}/${item.suffix.trim()}`
              : item.suffix
              ? item.suffix.trim()
              : item.prefix
              ? item.prefix.trim()
              : '',
          serialisactive: updatedObjectWithInt.serialisactive,
          serialflag: updatedObjectWithInt.taxability === 3 ? 1 : 0,
          taxability: updatedObjectWithInt.taxability,
          restrictedflag: updatedObjectWithInt.restrictedflag,
        };
        try {
          const resSalesSettings = await API.graphql(
            graphqlOperation(updateNumberTracker, {
              updateNumberTrackerInput: salesSettingsData,
            })
          );

          if (resSalesSettings.data.updateNumberTracker.statuscode !== 'ERROR') {
            setListItems([...listItems]);
            showSuccessSnackbar('Setting has been modified');
            handleClose();
            setEditID('');
            setItem(defaultSettings);
            setBackdropOpen(false);
          } else {
            showWarningSnackbar(resSalesSettings.data.updateNumberTracker?.statusmessage);
            setBackdropOpen(false);
          }
        } catch {
          console.log('err');
        } finally {
          setBackdropOpen(false);
        }
      } else {
        setBackdropOpen(true);
        const salesSettingsData = {
          entrytypecd: label,
          companyid: getCompany?.companyid,
          nextinvoicenumber: Number(item.nextinvoicenumber),
          prefix: item.prefix ? item.prefix.trim() : '',
          suffix: item.suffix ? item.suffix.trim() : '',
          financialyearid: setId,
          serialisused: 0,
          startinvoicenumber: Number(item.nextinvoicenumber),
          serialnumber:
            item.prefix && item.suffix
              ? `${item.prefix.trim()}/${item.suffix.trim()}`
              : item.suffix
              ? item.suffix.trim()
              : item.prefix
              ? item.prefix.trim()
              : '',
          serialisactive: 1,
          serialflag: item?.taxability === 3 ? 1 : 0,
          restrictedflag: item?.restrictedflag,
          taxability: label === 'SalesInvoice' || label === 'PosInvoice' ? item?.taxability : 0,
        };
        try {
          const resSalesSettings = await API.graphql(
            graphqlOperation(createNumberTracker, {
              createNumberTrackerInput: [salesSettingsData],
            })
          );
          if (resSalesSettings.data.createNumberTracker[0]?.statuscode !== 'ERROR') {
            handleClose();
            setEditID('');
            showSuccessSnackbar('Setting added');
            setItem(defaultSettings);
            setBackdropOpen(false);
          } else {
            showWarningSnackbar(resSalesSettings.data.createNumberTracker[0]?.statusmessage);
            setBackdropOpen(false);
          }
        } catch {
          console.log('err');
        } finally {
          setBackdropOpen(false);
        }
      }
    }
  };
  console.log(item, 'itemmmm');

  const INVOICE_REGEX = /^[A-Za-z1-9][A-Za-z0-9/-]*$/;
  const INVOICE_REGEX1 = /^[A-Za-z0-9/-]*$/;

  // Validation function for prefix
  const validatePrefix = (value) => {
    if (value === '') return true; // Allow empty prefix
    if (value.startsWith('0') || value.startsWith('/') || value.startsWith('-') || value.startsWith('\\')) {
      showWarningSnackbar('Prefix cannot start with 0, /, \\, or -');
      return false;
    }
    return true;
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={handleClose}
    >
      <Fade in={open}>
        <Paper sx={style}>
          <Box
            sx={{
              backgroundColor: 'primary.main',
              padding: '5px 15px',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: '#fff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                {editId?.id ? 'Edit' : 'Add'} {' ' + labelFn(label)} Settings
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: '#fff' }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Box
            sx={{
              padding: '15px',
              height: { xs: '400px', sm: 'auto' },
              overflowY: { xs: 'scroll', sm: 'hidden' },
              '.MuiTableCell-root': {
                padding: '10px 10px',
                fontSize: '13px',
              },
              '.MuiTableCell-head': {
                backgroundColor: 'background.tablebg',
                padding: '10px 8px',
                borderBottom: '0px',
                fontSize: '13px',
                fontWeight: 'bold',
              },
            }}
          >
            <Stack
              component="form"
              sx={{
                '.Mui-disabled': {
                  color: 'rgba(0, 0, 0, 0.6)',
                },
                width: '25ch',
              }}
              spacing={2}
              noValidate
              autoComplete="off"
            >
              <TextField
                id="Prefix"
                label="Prefix"
                size="small"
                value={item?.prefix}
                inputProps={{ maxLength: 10 }}
                onChange={(e) => {
                  const value = e.target.value;
                  const capitalizedValue = value === '' ? '' : value.charAt(0).toUpperCase() + value.slice(1);
                  if (value === '' || (INVOICE_REGEX.test(value) && validatePrefix(value))) {
                    setItem({ ...item, prefix: value });
                  } else {
                    setItem((prev) => ({
                      ...prev,
                      prefix: capitalizedValue,
                    }));
                    if (!validatePrefix(value)) {
                      showWarningSnackbar('Prefix cannot start with 0,/,-');
                    } else {
                      showWarningSnackbar('Please provide valid value');
                    }
                  }
                }}
                onBlur={() => {
                  setItem((prev) => ({
                    ...prev,
                    prefix: prev.prefix.replace(/\s+/g, ' ').trim(),
                  }));
                }}
              />
              <TextField
                label="Start Number"
                sx={{
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '20px',
                    fontWeight: 'bold',
                  },
                }}
                required={(item?.nextinvoicenumber === '' || item?.nextinvoicenumber === null) && true}
                onBlur={() => {
                  setItem((prev) => ({
                    ...prev,
                    nextinvoicenumber: prev?.nextinvoicenumber,
                  }));
                }}
                disabled={item?.serialisused === 1}
                value={item?.serialisused === 1 ? item?.startinvoicenumber : item?.nextinvoicenumber}
                onChange={(e) => {
                  const { value } = e.target;
                  if (/^[1-9][0-9]*$/.test(value) && value.length <= 9) {
                    setItem({ ...item, nextinvoicenumber: value });
                  } else if (value.length < 2) {
                    setItem({ ...item, nextinvoicenumber: '' });
                  }
                }}
                size="small"
              />
              {item?.serialisused === 1 && (
                <TextField
                  label="Last Voucher Number"
                  sx={{
                    '.MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontSize: '20px',
                      fontWeight: 'bold',
                    },
                  }}
                  required={(item?.nextinvoicenumber === '' || item?.nextinvoicenumber === null) && true}
                  onBlur={() => {
                    setItem((prev) => ({
                      ...prev,
                      nextinvoicenumber: prev?.nextinvoicenumber,
                    }));
                  }}
                  value={item?.nextinvoicenumber}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (/^[1-9][0-9]*$/.test(value) && value.length <= 9) {
                      setItem({ ...item, nextinvoicenumber: value });
                    } else if (value.length < 2) {
                      setItem({ ...item, nextinvoicenumber: '' });
                    }
                  }}
                  size="small"
                />
              )}
              <TextField
                id="Suffix"
                label="Suffix"
                size="small"
                value={item?.suffix}
                inputProps={{ maxLength: 10 }}
                onBlur={() => {
                  setItem((prev) => ({
                    ...prev,
                    suffix: prev?.suffix?.replace(/\s+/g, ' ')?.trim(),
                  }));
                }}
                onChange={(e) => {
                  if (INVOICE_REGEX1.test(e.target.value)) {
                    setItem({ ...item, suffix: e.target.value });
                  } else {
                    setItem((prev) => ({
                      ...prev,
                      suffix: e.target.value === '' ? '' : prev.suffix,
                    }));
                    showWarningSnackbar('Please provide valid value');
                  }
                }}
              />
              {(label === 'SalesInvoice' || label === 'PosInvoice') && (
                <Box>
                  <FormControl size="small" fullWidth>
                    <Select
                      disabled={item.serialisused}
                      value={item?.taxability || 1}
                      onChange={(e) => {
                        setItem({ ...item, taxability: e.target.value });
                      }}
                      sx={{ fontSize: '13px' }}
                    >
                      <MenuItem value={1} sx={{ fontSize: '13px' }}>
                        Taxable
                      </MenuItem>
                      <MenuItem value={3} sx={{ fontSize: '13px' }}>
                        Bill of supply
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              )}

              <Typography>
                Preview :
                {(item?.prefix ? item?.prefix : '') +
                  (item?.nextinvoicenumber ? item?.nextinvoicenumber : '') +
                  (item?.suffix ? item?.suffix : '')}
              </Typography>
            </Stack>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: { xs: 'column', sm: 'row' },
            }}
          >
            <Button
              onClick={handleSetting}
              variant="contained"
              sx={{ flex: 1, margin: '10px', fontSize: '12px' }}
              disabled={item?.nextinvoicenumber === null || item?.nextinvoicenumber === ''}
            >
              Save
            </Button>
            <Button onClick={handleClose} variant="outlined" sx={{ flex: 1, margin: '10px', fontSize: '12px' }}>
              Cancel
            </Button>
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
};

export default GeneralSettings;
